/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

import classNames from 'classnames';

import Tooltip from '../../Tooltip';
import classes from './styles.module.scss';

export default function TextInputSwitch({
  // Base TextInput props
  name,
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  touched,
  success,
  type,
  warning,
  width,
  height,
  readonly,
  maxLength,
  info,
  note,
  centerText,
  inputRef,
  onFocus,
  infoWidth,
  style,
  labelStyle,
  staticErrorPositon,
  icon,
  noteStyle,
  autoComplete,
  // Switch props (optional)
  switchName,
  switchValue,
  switchLabel,
  onSwitchChange,
  switchReadOnly,
  setFieldValue,
  setFieldTouched,
  // When true, clears the input value (name) when switch becomes false
  clearValueOnSwitchFalse,
}) {
  const labelId = `${name}-label`;

  const handleSwitchToggle = () => {
    const next = !switchValue;
    onSwitchChange?.(next);
    if (switchName && setFieldValue) {
      setFieldValue(switchName, next);
      setTimeout(() => setFieldTouched?.(switchName, true));
    }
    if (clearValueOnSwitchFalse && next === false && setFieldValue && name) {
      setFieldValue(name, '');
      setTimeout(() => setFieldTouched?.(name, true));
    }
  };

  const input = (
    <input
      autoComplete={autoComplete}
      style={{ ...style, width, height }}
      name={name}
      id={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onBlur={readonly ? () => {} : onBlur}
      onFocus={onFocus}
      type={type || 'text'}
      readOnly={readonly}
      maxLength={maxLength}
      ref={inputRef}
      aria-labelledby={label ? labelId : undefined}
    />
  );

  return (
    <div
      style={{ width }}
      className={classNames(classes.TextInputSwitch, {
        [classes.error]: error && touched,
        [classes.success]: !error && !warning && touched && value?.length,
        [classes.warning]: !error && warning && touched,
        [classes.centerText]: centerText,
        [classes.staticErrorPositon]: staticErrorPositon,
      })}
    >
      {(label || info || note || typeof switchValue === 'boolean') && (
        <div className={classes.labelRow}>
          <label style={{ display: label ? 'flex' : 'none', ...labelStyle }}>
            <span id={labelId}>{label}</span>{' '}
            {info && (
              <Tooltip text={info} width={infoWidth}>
                <i className={classes.infoIcon}>
                  <svg
                    width="3"
                    height="10"
                    viewBox="0 0 3 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1.25H1.03125"
                      stroke="#242833"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M1 8.75V4.75"
                      stroke="#242833"
                      strokeWidth="2"
                      strokeLinecap="square"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
              </Tooltip>
            )}{' '}
            {note && (
              <span className={classes.note} style={noteStyle}>
                ({note})
              </span>
            )}
          </label>
          {typeof switchValue === 'boolean' && (
            <button
              type="button"
              role="switch"
              aria-checked={switchValue}
              className={classNames(classes.switchControl, {
                [classes.enabled]: switchValue,
              })}
              onClick={handleSwitchToggle}
              disabled={switchReadOnly}
            >
              {switchLabel && (
                <span className={classes.switchText}>{switchLabel}</span>
              )}
              <span className={classes.track}>
                <span className={classes.thumb} />
              </span>
            </button>
          )}
        </div>
      )}

      {icon ? (
        <div className={classes.iconContainer} style={{ width }}>
          {input}
          <img src={icon} alt="icon" className={classes.icon} />
        </div>
      ) : (
        input
      )}
      {error && touched && <div className={classes.status}>{error}</div>}
      {!error && touched && success && (
        <div className={classes.status}>{success}</div>
      )}
      {!error && touched && warning && (
        <div className={classes.status}>{warning}</div>
      )}
    </div>
  );
}
